/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdAsideProps, TdFooterProps, TdHeaderProps, TdLayoutProps } from './type';

export const asideDefaultProps: TdAsideProps = {};

export const footerDefaultProps: TdFooterProps = {};

export const headerDefaultProps: TdHeaderProps = {};

export const layoutDefaultProps: TdLayoutProps = {};
